import { useCallback, useState } from "react";
import { getStatusPeriods } from "../services/getStatusPeriods";

export function useGetStatusPeriods() {
  const [periods, setPeriods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchStatusPeriods = useCallback(
    async ({ idPlanta, column, fechaInicio, fechaFin }) => {
      setLoading(true);
      setError(null);
      setPeriods([]);

      try {
        const data = await getStatusPeriods({
          idPlanta,
          column,
          fechaInicio,
          fechaFin
        });
        setPeriods(data);
      } catch (error) {
        setError(error);
        setPeriods([]);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { periods, loading, error, fetchStatusPeriods };
}
